@file:Suppress("unused")

package fr.arcplex.network.http

open class ClientException : Exception {

    /**
     * Constructs an [ClientException] with no detail message.
     */
    constructor() : super()

    /**
     * Constructs an [ClientException] with the specified detail message.
     * 
     * @param   message   the detail message.
     */
    constructor(message: String) : super(message)
}

open class ServerException : RuntimeException {

    /**
     * Constructs an [ServerException] with no detail message.
     */
    constructor() : super()

    /**
     * Constructs an [ServerException] with the specified detail message.

     * @param   message   the detail message.
     */
    constructor(message: String) : super(message)

    companion object {
        private const val serialVersionUID: Long = 456L
    }
}